<template>
  <div class="wrap">
    <div class="vip-persons-info">
      <div class="logonRight edit-pw">
        <h1 class="edit-password-h1">修改登陆密码</h1>
        <fy-form :model="form_info" :rules="rules" ref="form" v-if="!isInit">
          <p class="p2">
            <em></em>
            <fy-form-item :prop="fields.passwd.field_enname">
              <fy-input
                :placeholder="fields.passwd.field_placeholder"
                type="password"
                v-model.trim="form_info.passwd"
              ></fy-input>
            </fy-form-item>
          </p>
          <p class="p2">
            <em></em>
            <fy-form-item :prop="fields.new_passwd.field_enname">
              <fy-input
                :placeholder="fields.new_passwd.field_placeholder"
                type="password"
                v-model.trim="form_info.new_passwd"
              ></fy-input>
            </fy-form-item>
          </p>
          <p class="p2">
            <em></em>
            <fy-form-item :prop="fields.confirmPasswd.field_enname">
              <fy-input
                :placeholder="fields.confirmPasswd.field_placeholder"
                type="password"
                v-model.trim="form_info.confirmPasswd"
              ></fy-input>
            </fy-form-item>
          </p>
          <div class="phone-submit">
            <input
              @click="validatepasswd()"
              class="phone-submitBtn"
              name="edit_password"
              type="button"
              value="保存"
            >
          </div>
        </fy-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EditPassword',
  componentName: 'EditPassword',
  data () {
    return {
      type: 2,
      form_info: {
        passwd: '',
        new_passwd: '',
        confirmPasswd: '',
        username: ''
      },
      url: 'member/by_username/',
      update_url: 'member/update_passwd',
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      fields: {},
      rules: {}
    }
  },
  created () {
    if (this.$sessionStorageUtil.get('member_types') == 0) {
      this.$messageBox.alert('游客没有密码不需要修改!').then(() => {
        this.$router.push({ name: 'memberInfo' })
      })
    }
    this.$sessionStorageUtil.get('member_types')
    const username = this.$sessionStorageUtil.get('username')
    this.form_info.username = username
    this.$myGet(this.url + username).then(res => {
      this.type = res.response.data.member_info.passwd ? 2 : 1
      this.$pageField.init(this, 'fields', 'editPassword').then(res => {
        this.isInit = false //异步加载完成后设置为false
        this.rules.confirmPasswd[1].confirmProp = 'new_passwd'
      })
    }).catch(err => {
      this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
    })
  },
  methods: {
    validatepasswd () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          var loading = this.$loadingIndicator.eleOpen('信息审核中...')
          this.$myPut(this.update_url, this.form_info).then(res => {
            const rcode = res.response.data.rcode
            if (rcode == 0) {
              this.$sessionStorageUtil.set('next_message', '密码修改成功', 60 * 5)
              this.$pushByName('memberInfo')
              loading.close()
            } else {
              this.$msg(
                res.response.data.messages[0].msg, 'error'
              )
              loading.close()
            }
          }).catch(err => {
            loading.close()
            this.$msg('请求出错:[' + err.status + ']' + err.message, 'error')
          })
        } else {
          this.$msg(invalidFields[0].message, 'error')
        }
      })
    }
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/memberInfo.css';
</style>



// WEBPACK FOOTER //
// src/pages/customer/p_center/editPassword.vue